import { Pipe, PipeTransform } from '@angular/core';
import { StatusImportacaoMovimentacaoCadastral } from 'src/app/core/models/movimentacao-cadastral/StatusImportacaoMovimentacaoCadastral';

@Pipe({
  name: 'statusMovimentacao',
})
export class StatusMovimentacaoPipe implements PipeTransform {
  transform(status: StatusImportacaoMovimentacaoCadastral): string {
    const labels = {
      0: 'Erro',
      1: 'Em Andamento',
      2: 'Concluído Parcialmente',
      3: 'Concluido',
    };

    return labels[status];
  }
}
